/*
 * help.jsx
 * Copyright (c) Harman International Industries, Incorporated, 2024 - 2025
 * All rights reserved.
 */
import React from "react";
import Topheader from "../../../Layout/header/header";
import "./help.css";

function Help() {
  return (
    <div className="appListContainer">
      <Topheader />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "10%",
          width: "100%",
        }}
      >
        <div className="conatiner-help-tab mb-5">
          <div className="row">
            <div className="offset-md-2 col-md-8">
              <div className="content-header">
                <span className="title">Do you need help?</span>
              </div>
              <div className="content">
                <div className="main">
                  <p>
                    You can write us a message in our slack channel or reach us
                    out via{" "}
                    <span className="group-support-cariad-text">
                      groupappstore.support@cariad.technology
                    </span>
                  </p>
                </div>
                <div className="main">
                  <p>
                    In addition, you can take a look in our internal{" "}
                    <span className="group-support-cariad-text">
                      Group Developer guidelines launch{" "}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help;
